export default function CarteGoogle() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-4xl font-bold text-brand-blue mb-3">
            Où nous trouver
          </h2>
          <p className="text-brand-text text-base md:text-lg max-w-2xl mx-auto">
            Notre atelier est situé à Strasbourg, au cœur du Bas-Rhin. Nos techniciens se déplacent dans toute la région.
          </p>
        </div>
        <div className="w-full rounded-xl overflow-hidden border border-brand-border">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d168454.4757618647!2d7.68!3d48.58!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4796c84d7f5e3b1f%3A0x1c0c0c0c0c0c0c0c!2sStrasbourg!5e0!3m2!1sfr!2sfr!4v1600000000000!5m2!1sfr!2sfr"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Carte des zones d'intervention volet roulant Bas-Rhin"
            aria-label="Carte Google centrée sur Strasbourg et le Bas-Rhin"
          ></iframe>
        </div>
      </div>
    </section>
  );
}